import { render, staticRenderFns } from "./main.vue?vue&type=template&id=198d1136&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=198d1136&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198d1136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198d1136')) {
      api.createRecord('198d1136', component.options)
    } else {
      api.reload('198d1136', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=198d1136&scoped=true", function () {
      api.rerender('198d1136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileUpload/src/main.vue"
export default component.exports